import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';

export const useStyles = (isDebug: boolean = false) => {
  const { breakpoints } = useTheme();

  return {
    homeBarButton: {
      '& button': {
        padding: 1,
        width: isDebug ? 56 : 44,
        height: isDebug ? 56 : 44,

        [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
          padding: 0.5,
          width: isDebug ? 56 : 28,
          height: isDebug ? 56 : 28,
        },
      },
    },
    iconContainer: {
      top: '8px',
      width: isDebug ? 56 : 28,
      height: isDebug ? 56 : 28,
      position: 'absolute',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        top: 0,
        width: isDebug ? 56 : 24,
        height: isDebug ? 56 : 24,
      },
    },
    icon: {
      width: '100%',
      height: 'auto',
      borderRadius: '50%',
      overflow: 'hidden',
      border: '1px solid white',
    },
  };
};
